const AppraisalManagementRoute = ({children}) => {
  return children
}

export default AppraisalManagementRoute